/*
 * Created Date: 29-01-2024, 2:15:59 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Mar 11 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { IoSchool } from 'react-icons/io5'
import { workspaceExamNavigationConfig } from '../Exam/configs/navigation'
import { workspaceSystemNavigationConfig } from '../System/config/navigation'
import { workspaceCategoriesNavigationConfig } from '../Categories/configs/navigation'
import { workspaceTeamNavigationConfig } from '../Team/configs/navigation'

// import { WorkspaceCreateExamAINavigationConfig } from '../CreateExamAI/configs/WorkspaceCreateExamAINavigationConfig'
// import { workspaceQuestionCollectionNavigationConfig } from '../QuestionCollection/configs/navigation'
// import { workspaceQuestionCollectionNavigationConfig } from '../QuestionCollection/configs/navigation'
import { workspacePlanNavigationConfig } from '../Plan/configs/navigation'
import { workspaceClassRoomNavigationConfig } from '../ClassRoom/configs/navigation'
import { workspaceExamRoomNavigationConfig } from '../ExamRoom/config/navigation'

const WorkspaceNavigationConfig = {
	id: 'workspace',
	title: 'Quản lý',
	type: 'collapse',
	icon: <IoSchool />,
	isWorkspace: true,
	children: [
		// ...WorkspaceDashboardNavigationConfig,
		// ...WorkspaceCreateExamAINavigationConfig,
		// ...WorkspaceQuickCreateExamNavigationConfig,
		...workspaceExamNavigationConfig,
		...workspaceExamRoomNavigationConfig,

		// ...workspaceClassRoomNavigationConfig,
		// ...workspaceQuestionCollectionNavigationConfig,
		...workspaceCategoriesNavigationConfig,
		// ...WorkspaceExamNavigationConfig,

		...workspacePlanNavigationConfig,
		// ...workspaceTeamNavigationConfig,
		...workspaceSystemNavigationConfig
	]
}

export default WorkspaceNavigationConfig
